import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useCart } from "@/lib/cart";

const Shell = ({ testId, title, children }) => (
  <main data-testid={testId} className="mx-auto max-w-3xl px-5 md:px-10 pt-44 pb-32 min-h-[70vh]">
    <p className="eyebrow mb-6">Lise’s Sugar Studio</p>
    <h1 className="font-display font-light text-5xl md:text-7xl leading-[0.95]">{title}</h1>
    <div className="mt-8 text-mocha leading-relaxed text-lg">{children}</div>
  </main>
);

export const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const { clear } = useCart();
  const clearRef = useRef(clear);
  clearRef.current = clear;
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sid) {
      setStatus("error");
      return undefined;
    }
    let tries = 0;
    let t;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data?.payment_status === "paid") {
          setStatus("paid");
          clearRef.current();
          return;
        }
        if (data?.status === "expired") {
          setStatus("error");
          return;
        }
      } catch {
        setStatus("error");
        return;
      }
      tries += 1;
      if (tries < 10) t = setTimeout(poll, 2000);
      else setStatus("pending");
    };
    poll();
    return () => clearTimeout(t);
  }, [sid]);

  if (status === "paid")
    return (
      <Shell testId="payment-success" title={<>Thank you. <span className="italic text-mocha">It’s official.</span></>}>
        <p>Your order is confirmed and will be baked fresh. Pickup details for Clifton Heights, PA will be sent to you shortly.</p>
        <Link to="/shop" className="btn btn-dark mt-10">Continue Browsing</Link>
      </Shell>
    );
  if (status === "checking") return <Shell testId="payment-checking" title="Confirming your order…"><p>One moment while we confirm your payment.</p></Shell>;
  return (
    <Shell testId="payment-pending" title="We’re still confirming.">
      <p>We couldn’t confirm your payment yet. If you were charged, your order is safe; please reach out and we’ll sort it out.</p>
      <Link to="/contact" className="btn btn-line mt-10">Contact the Studio</Link>
    </Shell>
  );
};

export const PaymentCancel = () => (
  <Shell testId="payment-cancel" title="Checkout cancelled.">
    <p>No payment was taken. Your bag is still waiting whenever you’re ready.</p>
    <Link to="/shop" className="btn btn-dark mt-10">Back to Shop</Link>
  </Shell>
);
